export const NONE = 'NONE';
export const AFTER_X_TIMES = 'AFTER_X_TIMES';
export const AFTER_X_MINUTES = 'AFTER_X_MINUTES';
export const AFTER_X_HOURS = 'AFTER_X_HOURS';
export type SettingOption = typeof NONE | typeof AFTER_X_TIMES | typeof AFTER_X_MINUTES | typeof AFTER_X_HOURS;
export const DATAPOINTS_WITHOUT_DURATION_SETTINGS = ['button1pressed', 'button2pressed'];
